<!-- New code -->
<ng-template #pepperiTemplate>
    <mat-form-field [formGroup]="form" appearance="outline">
        <div class="pepperi-file-wrapper">
            <div class="pepperi-file body-sm" [style.height]="fieldHeight" [ngClass]="{
                    'one-row': rowSpan == 1,
                    disable: disabled
                }">
                <ng-container *ngIf="src != ''; then withImg; else noImg"></ng-container>
                <ng-template #withImg>
                    <button *ngIf="!disabled" mat-button (click)="deleteFile()"
                        class="pepperi-button icon-button weak md delete" tabindex="-1"
                        [ngClass]="{ 'right-alignment': xAlignment == '2' }">
                        <mat-icon>
                            <pep-icon name="system_bin">
                            </pep-icon>
                        </mat-icon>
                    </button>
                    <div class="pepperi-file-preview" (click)="onElementClicked($event)">
                        <img *ngIf="controlType === 'image'" #imagePreview [src]="src" class="pepperi-file-preview-img"
                            [style.max-height]="fieldHeight" (error)="errorHandler($event)" [alt]="label"
                            [ngClass]="['text-align-' + xAlignment]" />
                        <div *ngIf="controlType === 'attachment'" class="ellipsis pepperi-file-message">
                            <a *ngIf="src != ''" href="javascript:void(0)">
                                <pep-icon name="system_attach">
                                </pep-icon>
                                <span class="body-sm ellipsis">{{ 'FILE.SEE_ORIGINAL' | translate }}</span>
                            </a>
                        </div>
                    </div>
                </ng-template>
                <ng-template #noImg>
                    <div class="ellipsis pepperi-file-message">
                        <pep-icon *ngIf="controlType === 'attachment'" name="system_attach">
                        </pep-icon>
                        <pep-icon *ngIf="controlType === 'image'" name="system_file_upload_cloud">
                        </pep-icon>
                        <span class="body-sm ellipsis" *ngIf="progress == 0">
                            {{ (disabled ? (controlType === 'image' ? 'MESSAGES.INFO_MISSING_IMAGE' : 'MESSAGES.INFO_MISSING_FILE') : 'FILE.HINT') | translate }}
                        </span>
                        <!-- <p *ngIf="progress != 0" class="pull-left flip"
                            [ngClass]="{ 'pull-left flip': rowSpan == 1, image: controlType == 'image', attachment: controlType == 'attachment' }">
                            {{ 'FILE.UPLOADING_FILE' | translate }}
                        </p> -->
                    </div>
                    <ng-container *ngIf="!disabled">
                        <input #fileInput id="pepperi-file-{{ key }}" tabindex="-1" type="file"
                            accept="acceptedExtensions" ng2FileSelect [uploader]="uploader" autocomplete="off" />
                        <button *ngIf="progress != 0" mat-button class="pepperi-button icon-button weak md delete"
                            [ngClass]="{ 'right-alignment': xAlignment == '2' }">
                            <mat-icon>
                                <pep-icon name="system_processing" class="spin-icon">
                                </pep-icon>
                            </mat-icon>
                        </button>
                    </ng-container>
                </ng-template>
            </div>
            <input [id]="key" matInput [name]="key" [formControlName]="key" class="hidden-input" type="text"
                [value]="src" [disabled]="disabled" (click)="onClick_ChooseFile($event)"
                (keypress)="onKeyPress_ChooseFile($event)" autocomplete="off" />
        </div>

        <mat-error><span class="body-xs"
                [title]="required && src.length == 0 ? ('MESSAGES.ERROR_IS_REQUIRED' | translate: { field: label }) : ('MESSAGES.ERROR_IS_NOT_VALID' | translate: { field: label })"
                [innerText]="required && src.length == 0 ? ('MESSAGES.ERROR_IS_REQUIRED' | translate: { field: label }) : ('MESSAGES.ERROR_IS_NOT_VALID' | translate: { field: label })"></span>
        </mat-error>
    </mat-form-field>
</ng-template>

<ng-container *ngIf="layoutType === LAYOUT_TYPE.PepperiForm">
    <ng-container *ngTemplateOutlet="pepperiTemplate"></ng-container>
</ng-container>

<ng-container *ngIf="layoutType === LAYOUT_TYPE.PepperiCard">
    <!-- <ng-container *ngTemplateOutlet="pepperiTemplate"></ng-container> -->
</ng-container>

<ng-container *ngIf="layoutType === LAYOUT_TYPE.PepperiTable">
    <!-- <ng-container *ngTemplateOutlet="pepperiTemplate"></ng-container> -->
</ng-container>